export default {
  sidebar: {
    manageLegalAccount: "Manage Legal Account",
    managePasswordUsername2FA:
      "Manage Password, Username and Two-Factor Authentication",
    personalAccountSignin: "Sign in to Personal Account",
    legalAccountDashboard: "Legal Account Dashboard",
    signatureCartable: "Signature Cartable",
    viewLicensesForRequests: "View Licenses to Approve or Reject Requests",
    manageTransactions: "Manage Transactions",
    personalContactAndIDPhoto:
      "Personal Information, Contact Info and ID Verification Photo",
    bankInfoAndAddresses: "Bank Information and Addresses",
    walletAddressesAndBankAccounts:
      "Wallet Addresses, Sheba Numbers and Bank Cards",
    identityInformation: "Identity Information",
    youAreInLegalAccount: "You are now in your legal account"
  },
  mainDashboard: {
    legalAccountSignin: "You have signed in to your legal account",
    dontShowAgain: "Don’t show me again"
  },
  corporateDashboard: {
    legalCompaniesRules: "Legal Companies Rules and Regulations",
    legalCompaniesRulesDescription:
      "Here you can read the rules of legal companies"
  },
  manage: {
    createLegalAccount: "Create Legal Account",
    createLegalAccountDescription: "Here you can create your legal account",
    legalAccountsList: "List of Legal Accounts",
    legalAccountsListDescription:
      "Here you can see the list of companies you have created",
    legalAccountNote:
      "Please note, to expedite creating a legal account, all company members must have an Excoino account and complete identity verification",
    create: {
      step1: {
        legalAccountInstructions:
          "To create a legal account, you need to download the file below and accurately fill in your documents as specified, then upload them on the next page.",
        companyName: "Company Name",
        companyMembersCount: "Number of Company Members",
        requiredDocumentsFile: "Required Documents File",
        submitAndContinue: "Submit and Continue",
        uploadDocuments: "Upload Documents",
        reviewDocuments: "Review Documents",
        editLegalAccountDocuments: "Edit Legal Account Documents",
        documentsNeedCorrection:
          "The following items need correction and must be re-uploaded correctly",
        viewAllCompanyMembersAccess: "View Access of All Company Members",
        deposit: "Deposit",
        active: "Active",
        withdrawal: "Withdrawal",
        requiresAllMembersApproval: "Requires Approval of All Members",
        spotTrades: "Spot Trades",
        OTCTrades: "OTC Trades",
        staking: "Staking",
        transferToMarketWallet: "Transfer to Market Wallet"
      },
      step2: {
        uploadRequiredDocuments:
          "Here you need to upload the required documents",
        allowedFileFormats: "Allowed file formats: {formats}"
      },
      step3: {
        legalAccountRequestSubmitted:
          "Your request to create a legal account has been successfully submitted",
        legalAccountNextSteps:
          "After approval, you can access your legal account through the profile panel. If the documents are not approved, you will be notified via support or email to correct them."
      }
    }
  },
  companyInformation: {
    companyInformation: "Company Information",
    companyInformationNote:
      "Pay attention to the company’s annual book date, as on the due date you must send documents to continue your activity",
    annualBookDate: "Annual Book Date",
    companyName: "Company Name",
    nationalID: "National ID",
    establishmentDate: "Establishment Date",
    userType: "User Type",
    legal: "Legal"
  },
  permissionsCartable: {
    licensesCartable: "Licenses Cartable",
    noWithdrawalFound: "No withdrawal found",
    withdrawal: "Withdrawal",
    requester: "Requester",
    cryptoWithdrawal: "Crypto Withdrawal",
    rialWithdrawal: "Rial Withdrawal"
  },
  membersList: {
    signersList: "List of Authorized Signatories"
  },
  guideCard: {
    legalAccountReminder:
      "Please note, to expedite creating a legal account, all company members must have an Excoino account and complete identity verification."
  },
  signCreate: {
    confirmLegalAccountCreation:
      "By confirming on this page, you declare permission to create the company as main members",
    acceptLegalAccountRules:
      "By reading the above rules, I accept that the legal company account be created",
    revokeLegalAccountPermission: "Revoke Legal Account Creation Permission",
    revokeLegalAccountPermissionConfirmation:
      "Are you sure you want to revoke this permission? To create a legal account, all members must accept the conditions of company creation",
    revokeLegalAccountPermissionConfirmButton: "Yes, revoke it"
  },
  signCrypto: {
    currencyType: "Currency Type",
    youSend: "You Send",
    destinationWalletAddress: "Destination Wallet Address",
    networkType: "Network Type",
    amountExcludingFee: "Amount Excluding Fee",
    fee: "Fee",
    description: "Description",
    cancelTransaction: "Cancel Transaction",
    submitSignature: "Submit Signature",
    youReceive: "You Receive",
    orderNumber: "Order Number",
    accountHolderName: "Account Holder Name",
    shebaNumber: "Sheba Number",
    revokeConfirmation: "Are you sure you want to revoke this permission?"
  }
};
